import { ABOUT } from "@/constants/testIds";

export default function AboutHero() {
  return (
    <section className="relative pt-40 md:pt-52 pb-24">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-8">
            <div className="eyebrow mb-8">The Atelier</div>
            <h1
              data-testid={ABOUT.pageTitle}
              className="font-serif text-6xl md:text-[8rem] leading-[0.92] tracking-tighter font-light"
            >
              A house of <em className="italic text-indigo_deep">slow,</em>
              <br />
              deeply cultural <br />
              travel.
            </h1>
          </div>
          <div className="col-span-12 md:col-span-4 md:mt-12">
            <p className="text-lg text-ink/80 leading-[1.85] font-light">
              Indiora Journeys is a small atelier of curators, scholars, and
              cultural concierges devoted to the refined art of South Asian
              travel. We do not sell itineraries — we compose them, one
              conversation at a time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
